import React from 'react';

export interface IPageHeaderMeta {
  title: string;
  subtitle?: string;
}

type Setter = (meta: IPageHeaderMeta | null) => void;

/** Lets a screen rendered inside <Layout> set the desktop header text. */
export const PageHeaderContext = React.createContext<Setter>(() => undefined);

/**
 * Sets the header card's title/subtitle from inside a page that is wrapped by
 * <Layout> elsewhere. Pass `null` to leave the header to someone else.
 */
export const usePageHeader = (meta: IPageHeaderMeta | null) => {
  const set = React.useContext(PageHeaderContext);
  const title = meta?.title;
  const subtitle = meta?.subtitle;
  React.useEffect(() => {
    set(title ? { title, subtitle } : null);
    return () => set(null);
  }, [set, title, subtitle]);
};
